import {grey} from '@material-ui/core/colors';
import {SideBar} from '../../variables/config.jsx';


const styles = theme => ({
  platformLogo:{
    background:'white',
    borderRadius:8,
  },
  hide: {
    display: 'none',
  },
  drawerPaper:{
    background: theme.palette.primary.main,
    overflowX: 'hidden',
    position:'relative',
    width: `${SideBar.width}px`,
    height:'100vh',
    boxShadow: "0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)",
    margin:'0px',
    border:'0px',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.easeIn,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.down('sm')]: {
      background: 'white',
    },

  },
  drawerPaperClose: {
    overflow: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: `${SideBar.minWidth}px`,
  },
  logo: {
    display:'block',
    margin:'auto',
    width: '80%',
    padding: '10px'
  },
  avatar: {
    display:'block',
    margin:'auto',
    width: '50%',
    padding: '10px',
    borderRadius:'50%',
  },
  avatar2: {
    display:'block',
    margin:'auto',
    width: '30%',
    padding: '10px',
    borderRadius:'90%',
  },
  button:{
    background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main} )`,
    borderRadius:'40px',
    padding: '3px 10px',
    marginTop: '20px',
    color:'white',
    height:'40px',
    width:'200px'
    
  },
  pad:{
   
  },
  color: {
    color: 'white',
    
  },
  title:{
    textAlign: 'center',
    fontWeight: 'bold',
  },
  title2:{
    color:grey[600],
    fontWeight:'500',
   
  },
  title3:{
    color:grey[600],
    fontWeight:'500',
    
  },
  icon:{
    color:grey[700]
  },
  bor: {
    border: '1px solid red'
  }
});

export default styles;
